import { Component, Input } from '@angular/core';
// import { DomSanitizer } from '@angular/platform-browser';

export interface IErrorMessage {
  msgImgUrl?: string;
  msgTitle?: string;
  msgBody?: string;
}

@Component({
  selector: 'gn-alert-error',
  templateUrl: './alert-error.component.html',
  styleUrls: ['./alert-error.component.scss']
})
export class AlertErrorComponent {

  @Input() errorMessage: IErrorMessage;
  @Input() alertsUrl: string;



  constructor() {
  }

}
